// extracted by mini-css-extract-plugin
export default {"mCard":"JD-z","image":"KD-z","imageNoBackground":"LD-z","imageHasCategory":"MD-z","fullWidth":"ND-z"};